import { useContext } from "react";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation bulkUpdateNextWorkflowSortOrder($updatedNextWorkflowSequences: [ID]!) {
          bulkUpdateNextWorkflowSortOrder(updatedNextWorkflowSequences: $updatedNextWorkflowSequences) {
            success
          }
    }`;

  const resolver = ({ data: { bulkUpdateNextWorkflowSortOrder } }) => {
    return { data: bulkUpdateNextWorkflowSortOrder };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useBulkUpdateNextWorkflowSortOrder() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (updatedSequence) => {
    return mutate({
      updatedNextWorkflowSequences: updatedSequence.map(({ id }) => {
        return toGlobalId("NextWorkflow", id);
      }),
    })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        console.error("Failed to update next workflow sort order", e);
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to reorder next workflows, please retry or contact support for assistance",
          e
        );
      });
  };
}

export default useBulkUpdateNextWorkflowSortOrder;
